export enum DeviceType {
    None,
    IOS,
    Android,
    Web,
    Huawei,
    MobileBrowser,
}

export enum PaymentType {
    None,
    Stripe,
}

export enum OrderType {
    Package,
}
